import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { sysRoutes } from './_sys';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(sysRoutes)
  ]
})
export class SysModule { }
